import React, { useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Delete,
  Edit,
  Visibility,
  CloudUpload,
} from '@mui/icons-material';
import PageHeader from '../common/PageHeader';
import StatusBadge from '../common/StatusBadge';
import EmptyState from '../common/EmptyState';

const DocumentList = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Mock data - replace with actual API call
  const documents = [
    {
      id: '1',
      title: 'Study Protocol',
      category: 'Essential Documents',
      version: '1.0',
      uploadDate: '2024-03-15',
      status: 'Active',
    },
    // Add more mock documents
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <PageHeader
        title="Document Management"
        actions={
          <Button
            variant="contained"
            startIcon={<CloudUpload />}
            onClick={() => {/* Handle upload */}}
          >
            Upload Document
          </Button>
        }
      />
      {documents.length === 0 ? (
        <EmptyState title="No documents yet" description="Uploaded documents will appear here." />
      ) : (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Upload Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((doc) => (
                <TableRow key={doc.id}>
                  <TableCell sx={{ fontWeight: 600 }}>{doc.title}</TableCell>
                  <TableCell>{doc.category}</TableCell>
                  <TableCell>{doc.version}</TableCell>
                  <TableCell>{doc.uploadDate}</TableCell>
                  <TableCell><StatusBadge status={doc.status} /></TableCell>
                  <TableCell align="right">
                    <Tooltip title="View">
                      <IconButton size="small" onClick={() => {/* Handle view */}}>
                        <Visibility fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit">
                      <IconButton size="small" onClick={() => {/* Handle edit */}}>
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton size="small" onClick={() => {/* Handle delete */}}>
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={documents.length}
          page={page}
          onPageChange={(_, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </TableContainer>
      )}
    </Box>
  );
};

export default DocumentList;